import React, { useEffect, useState } from "react";
import { GradingAIFeedback } from "../../components/ai_feedback/GradingAIFeedback.jsx";
import PropTypes from "prop-types";
import { StaticAIFeedback } from "../../components/ai_feedback/StaticAIFeedback.jsx";

export const B2CAssessmentFeedback = ({
  questions,
  currentPage,
  isReview,
  status,
  ai_grading_exercise,
}) => {
  let margin = "mb-1";

  const [currentQuestion, setCurrentQuestion] = useState(currentPage);
 
  useEffect(() => {
    setCurrentQuestion(currentPage);
  }, [currentPage]);
    
  return (
    <div className="col-12">
      {questions &&
        questions.map((question, qai) => {
          if (
            isReview ||
            status === null ||
            parseInt(currentQuestion) === parseInt(question.page)
          ) {
            return (
                <div className={`${margin}`} key={qai}>
                {isReview && question?.type === "FillInBlank" && ai_grading_exercise ? <GradingAIFeedback question={question} />
                : isReview && question?.ai_feedback ? <StaticAIFeedback question={question} all_questions={questions} />
                : null }
                </div>
            );
          } else {
            return null;
          }
        })}

    </div>
  );
};

B2CAssessmentFeedback.defaultProps = {
  questions: [],
  currentQuestion: 1,
  isReview: false,
};

B2CAssessmentFeedback.propTypes = {
  questions: PropTypes.array.isRequired,
  currentQuestion: PropTypes.number.isRequired,
  isReview: PropTypes.bool,
};

